import { call, put, takeEvery } from "redux-saga/effects";
import * as api from "../../../api/api";
import { emitJourneyEvent, JOURNEY_STEP_TYPES } from "../../../utils/journeyMonitoring";
import {
  SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST,
  submitDeclinePartialSaveSuccess,
  submitDeclinePartialSaveFailed,
} from "../actions";
import { buildDeclinePartialSavePayload } from "../helpers";
import { DeclinePartialSaveRequestPayload } from "../types";

export function* submitDeclinePartialSave(action: {
  type: string;
  payload: DeclinePartialSaveRequestPayload;
}) {
  const { serviceRequestPayload, partnerCode, history, dispatch } = action.payload;
  try {
    const payloadWithDeclineComment = buildDeclinePartialSavePayload(serviceRequestPayload);
    const response = yield call(api.saveRescueDetails, payloadWithDeclineComment, partnerCode, "", history, dispatch);
    // saveRescueDetails resolves with err.response on HTTP errors, so check status rather than relying on a throw.
    const status = response?.status;
    if (status >= 200 && status < 300) {
      emitJourneyEvent(JOURNEY_STEP_TYPES.USER_MILESTONE, "oem_deflection.declined", {
        milestoneName: "oem_deflection.declined",
        partnerCode,
      });
      yield put(submitDeclinePartialSaveSuccess());
    } else {
      emitJourneyEvent(JOURNEY_STEP_TYPES.API_FAILURE, "oem_deflection.decline_save_failed", {
        milestoneName: "oem_deflection.decline_save_failed",
        partnerCode,
        status,
      });
      yield put(submitDeclinePartialSaveFailed(response));
    }
  } catch (error) {
    emitJourneyEvent(JOURNEY_STEP_TYPES.API_FAILURE, "oem_deflection.decline_save_failed", {
      milestoneName: "oem_deflection.decline_save_failed",
      partnerCode,
    });
    yield put(submitDeclinePartialSaveFailed(error));
  }
}

export function* watchSubmitDeclinePartialSave() {
  yield takeEvery(SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST, submitDeclinePartialSave);
}
